import { delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { feeScheduleReceived, setFeeSchedule, setFeeScheduleDataFetching } from './actions';

import { ApiResponse } from 'apisauce';
import { FeeSchedule } from './types';
import { FeeScheduleAction } from './actions';
import { HealAPI } from '../../healApi';
import { ReduxAction } from '../core';
import { RootState } from '../types';

function* fetchFeeSchedules() {
  const state: RootState = yield select((s) => s);
  const { payerId, billingProviderId, cptSearch } = state.feeSchedule;

  if (!payerId || !billingProviderId) {
    return;
  }

  yield put(setFeeScheduleDataFetching(true));

  let results: ApiResponse<FeeSchedule[]>;
  if (cptSearch) {
    results = yield HealAPI.fetchFeeSchedulesByPayerAndBillingProviderAndCpt(payerId, billingProviderId, cptSearch);
  } else {
    results = yield HealAPI.fetchFeeSchedulesByPayerAndBillingProvider(payerId, billingProviderId);
  }

  if (results.ok && results.data) {
    yield put(setFeeSchedule(results.data));
  }
  yield put(setFeeScheduleDataFetching(false));
}

function* saveFeeSchedule(message: ReduxAction<{ feeSchedule: FeeSchedule; isNew: boolean }>) {
  const { feeSchedule, isNew } = message.data;

  let saveResponse: ApiResponse<FeeSchedule>;
  if (isNew) {
    const removeIdFs: any = feeSchedule;
    removeIdFs.id = undefined;
    saveResponse = yield HealAPI.createFeeSchedule(removeIdFs);
  } else {
    saveResponse = yield HealAPI.updateFeeSchedule(feeSchedule);
  }

  if (saveResponse.ok && saveResponse.data) {
    yield put(feeScheduleReceived(saveResponse.data));
  }
}

function* debounceFetchFeeSchedules() {
  yield delay(250);
  yield fetchFeeSchedules();
}

export function* feeScheduleFlow() {
  yield takeLatest([FeeScheduleAction.SET_CPT_SEARCH], debounceFetchFeeSchedules);

  yield takeEvery([FeeScheduleAction.SAVE_FEE_SCHEUDLE], saveFeeSchedule);

  yield takeLatest([FeeScheduleAction.SET_PAYER_ID, FeeScheduleAction.SET_BILLING_PROVIDER_ID], fetchFeeSchedules);
}
